// Confirming that somebody wants to come off the list.
//
// Asked because it cannot be undone from here: nothing is deleted on the
// server, but reopening a closed request is a staff action. So the dialog says
// what is lost — the time already waited — rather than a generic "are you
// sure", which is the version people click through without reading.

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";

/** How long they have been waiting, in the words a person would use. */
function waitedFor(createdAt) {
  const since = Number(createdAt);
  if (!Number.isFinite(since)) return "";
  const days = Math.floor((Date.now() - since) / 86_400_000);
  if (days < 1) return "since today";
  if (days === 1) return "since yesterday";
  if (days < 30) return `for ${days} days`;
  const months = Math.round(days / 30);
  return months === 1 ? "for about a month" : `for about ${months} months`;
}

export default function LeaveWaitlistDialog({
  isOpen,
  onClose,
  entry,
  serviceName,
  onConfirm,
  isLoading,
}) {
  const waited = entry ? waitedFor(entry.createdAt) : "";

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg">Leave this waitlist?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="sm" color="#1a1f36">
            You will stop being offered openings for{" "}
            {serviceName || "this appointment"}.
          </Text>
          {waited && (
            <Text fontSize="13px" color="#6b7280" mt={2}>
              You have been on this list {waited}. Joining again starts that
              over, so call the clinic if you only want to change your
              availability.
            </Text>
          )}
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" size="sm" onClick={onClose}>
            Stay on the list
          </Button>
          <Button
            colorScheme="red"
            size="sm"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            Leave the list
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
